import { Container, Row, Col, Card } from "react-bootstrap";
import './index.css';
import { BsCalendarCheck, BsClipboardCheck, BsCurrencyDollar, BsFileEarmarkBarGraph, BsPersonCheck, BsShieldLock } from "react-icons/bs";

const Features = () => {
  return (
    <section className="feature-wrapper bg-white" id="features">
      <Container>
        <h2 className="fw-bold text-center mb-3">Powerful Features to Simplify Real Estate Management</h2>
        <p className="text-center mb-5">
          From lead tracking to financial reports, our CRM helps you manage every aspect of your real estate business with ease.
        </p>
        <Row className="g-4">
          <Col md={6} lg={4}>
            <Card className="p-4 border-0 shadow-sm h-100">
              <BsClipboardCheck size={50} className="text-primary mb-3 mx-auto" />
              <h5 className="text-center">Lead Management</h5>
              <p className="text-center">
                Capture, organize, and nurture leads efficiently. Assign follow-ups, automate reminders, and convert leads into customers with ease.
              </p>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="p-4 border-0 shadow-sm h-100">
              <BsPersonCheck size={50} className="text-success mb-3 mx-auto" />
              <h5 className="text-center">Automated Follow-ups</h5>
              <p className="text-center">
                Keep prospects engaged with automated emails, calls, and notifications. Never miss a follow-up again!
              </p>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="p-4 border-0 shadow-sm h-100">
              <BsCurrencyDollar size={50} className="text-danger mb-3 mx-auto" />
              <h5 className="text-center">Flexible Installments</h5>
              <p className="text-center">
                Provide customers with installment-based payment plans. Automate reminders and track payments effortlessly.
              </p>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="p-4 border-0 shadow-sm h-100">
              <BsFileEarmarkBarGraph size={50} className="text-warning mb-3 mx-auto" />
              <h5 className="text-center">Financial Reports & Insights</h5>
              <p className="text-center">
                Gain real-time financial insights with revenue tracking, expense management, and detailed performance reports.
              </p>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="p-4 border-0 shadow-sm h-100">
              <BsCalendarCheck size={50} className="text-info mb-3 mx-auto" />
              <h5 className="text-center">Booking & Property Management</h5>
              <p className="text-center">
                Schedule property bookings, manage customer inquiries, and track availability with ease.
              </p>
            </Card>
          </Col>
          <Col md={6} lg={4}>
            <Card className="p-4 border-0 shadow-sm h-100">
              <BsShieldLock size={50} className="text-dark mb-3 mx-auto" />
              <h5 className="text-center">Secure & Scalable</h5>
              <p className="text-center">
                Ensure data security with encrypted transactions. Our CRM scales with your business growth.
              </p>
            </Card>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Features;